import { Link } from "react-router-dom";
import { BRAND } from "@/brand.config";

export default function AboutProgram() {
  return (
    <div className="max-w-[1100px] mx-auto px-6 lg:px-12 py-20" data-testid="page-about">
      <div className="text-[11px] uppercase tracking-[0.3em] kazo-text-burgundy mb-4">ABOUT THE PROGRAMME</div>
      <h1 className="editorial-headline text-5xl lg:text-7xl mb-8">A members-only<br /><em className="font-light">universe.</em></h1>
      <div className="prose max-w-3xl text-neutral-700 leading-relaxed text-lg">
        <p>{BRAND.loyaltyProgramName} is the official loyalty programme of {BRAND.legalName} for {BRAND.audienceDescriptor}. Every skincare essential, lipstick, haircare ritual and fragrance you pick up earns points — and unlocks birthday treats, tier privileges and first access to new beauty launches.</p>
        <p className="mt-6">There are no annual fees and no fine print buried in legalese. Just a programme that rewards what you already love — your everyday beauty routine.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-8 mt-16">
        {[
          { h: "Free to join", b: `No fee, no waitlist. Sign up in 30 seconds at any ${BRAND.name} store or online.` },
          { h: "Universally accepted", b: `Earn and redeem in any of our ${BRAND.storeCountLine} and on ${BRAND.domain}.` },
          { h: "Made for beauty lovers", b: "Personal beauty edits, launch previews and expert tips — by us, for you." },
        ].map((c) => (
          <div key={c.h} className="border border-black/10 p-8 bg-white">
            <h3 className="font-display text-2xl mb-2">{c.h}</h3>
            <p className="text-sm text-neutral-600 leading-relaxed">{c.b}</p>
          </div>
        ))}
      </div>
      <p className="mt-12 text-sm text-neutral-600" data-testid="about-legal-entity">Programme operated by {BRAND.legalEntity} · {BRAND.headOffice}</p>
      <Link to="/" className="mt-6 inline-block k-btn kazo-bg-burgundy uppercase tracking-widest text-xs">Join now</Link>
    </div>
  );
}
